import type { MouseEvent } from 'react';
import type { TemporaryNeedHelpState } from '../../lib/liveLessonTypes';
import { getPhotoUrl } from '../../lib/photoUtils';
import StudentSeatCard from './StudentSeatCard';

export type LiveStudentSeat = {
  id: string;
  firstName: string;
  lastName: string;
  row?: number;
  col?: number;
  bookingCount?: number;
};

type SeatingLiveCanvasProps = {
  students: Array<LiveStudentSeat | null>;
  columns: number;
  helpStates: TemporaryNeedHelpState[];
  awayStudentIds?: Set<string>;
  busyStudentId?: string | null;
  selectedStudentIds?: Set<string>;
  onStudentAward: (student: LiveStudentSeat) => void;
  onStudentSelect: (student: LiveStudentSeat, index: number, event: MouseEvent<HTMLButtonElement>) => void;
  onStudentOpenMenu: (student: LiveStudentSeat, coords: { clientX: number; clientY: number }) => void;
};

export default function SeatingLiveCanvas({
  students,
  columns,
  helpStates,
  awayStudentIds,
  busyStudentId = null,
  selectedStudentIds,
  onStudentAward,
  onStudentSelect,
  onStudentOpenMenu
}: SeatingLiveCanvasProps) {
  const helpSet = new Set(helpStates.filter((entry) => entry.active).map((entry) => entry.studentId));

  return (
    <div
      className="grid gap-3"
      style={{
        gridTemplateColumns: `repeat(${Math.max(1, columns)}, minmax(0, 1fr))`
      }}
    >
      {students.map((student, index) =>
        student ? (
          <StudentSeatCard
            key={student.id}
            student={student}
            photoUrl={getPhotoUrl(student.id)}
            badgeCount={student.bookingCount || 0}
            badgeTitle="Belege"
            accent={
              awayStudentIds?.has(student.id) ? 'away' : helpSet.has(student.id) ? 'needs_help' : 'none'
            }
            selected={selectedStudentIds?.has(student.id) ?? false}
            disabled={busyStudentId === student.id}
            onAward={() => onStudentAward(student)}
            onSelect={(event) => onStudentSelect(student, index, event)}
            onOpenMenu={(coords) => onStudentOpenMenu(student, coords)}
          />
        ) : (
          <div
            key={`empty-${index}`}
            className="aspect-square rounded-xl border border-dashed border-gray-300 bg-gray-50 dark:border-gray-600 dark:bg-gray-800/40"
          />
        )
      )}
    </div>
  );
}
